import { Col, Row } from "reactstrap"

const ChartFooterCard = ({ data, theme = "orange" }) => {
  let backgroundColor = "#fff2e6"
  let color = "#fd781f"

  if (theme === "blue") {
    backgroundColor = "#32383f"
    color = "#48b9e2"
  }

  return (
    <Row>
      {data?.map((item, index) => (
        <Col key={index}>
          <Row className="g-3 align-items-center">
            <Col xs="auto">
              <div className="p-2 rounded d-flex align-items-center justify-content-center" style={{ backgroundColor, color, width: '31px', height: '31px' }}>{item.icon}</div>
            </Col>
            <Col>
              <div>
                <div>{item.info.label}</div>
                <div>{item.info.value}</div>
              </div>
            </Col>
            <Col xs="auto">
              <div>
                {item.stats.icon} {item.stats.value}
              </div>
            </Col>
          </Row>
        </Col>
      ))}
    </Row>
  )
}

export default ChartFooterCard
